exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".important--text{font-weight:700}.breakable{word-break:break-all;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33feb4ce","scoped":false,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/confirmation/style.scss
// module id = 250
// module chunks = 0